import { render, staticRenderFns } from "./SettingsMrDocumentBlocks.vue?vue&type=template&id=af4b025a"
import script from "./SettingsMrDocumentBlocks.vue?vue&type=script&lang=js"
export * from "./SettingsMrDocumentBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports